"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkProvider = void 0;
const domain_1 = require("../../../domain");
const lodash_1 = __importDefault(require("lodash"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const BaseDataProvider_1 = require("./BaseDataProvider");
class BookmarkProvider extends BaseDataProvider_1.BaseDataProvider {
    constructor() {
        super(...arguments);
        this.bookmarksQuery = (options) => {
            let query = this.refs.bookmarksCollection();
            query = lodash_1.default.isNil(options.type) ? query : query.where('type', '==', options.type);
            query = lodash_1.default.isNil(options.types) ? query : query.where('type', 'in', options.types);
            query = lodash_1.default.isNil(options.groupId) ? query : query.where('groupId', '==', options.groupId);
            query = lodash_1.default.isNil(options.userId) ? query : query.where('userId', '==', options.userId);
            query = lodash_1.default.isNil(options.assignmentId) ? query : query.where('assignmentId', '==', options.assignmentId);
            query = lodash_1.default.isNil(options.isHidden) ? query : query.where('isHidden', '==', options.isHidden);
            query = lodash_1.default.isNil(options.isArchived) ? query : query.where('isArchived', '==', options.isArchived);
            query = lodash_1.default.isNil(options.lockStudent) ? query : query.where('lockStudent', '==', options.lockStudent);
            query = lodash_1.default.isNil(options.testPhase) ? query : query.where('testPhase', '==', options.testPhase);
            query = lodash_1.default.isNil(options.beforeDate) ? query : query.where('createdAt', '<', options.beforeDate.getTime());
            query = lodash_1.default.isNil(options.createdAfter)
                ? query
                : query.where('createdAt', '>=', options.createdAfter.getTime()).orderBy('createdAt', 'desc');
            query = lodash_1.default.isNil(options.orderByDate) ? query : query.orderBy('createdAt', 'desc');
            query = lodash_1.default.isNil(options.limit) ? query : query.limit(options.limit);
            query = lodash_1.default.isNil(options.modules) ? query : query.where('module', 'in', options.modules);
            //TEMP FOR MIGRATION
            query = lodash_1.default.isNil(options.createdBeforeDescending)
                ? query
                : query.where('createdAt', '<', options.createdBeforeDescending.getTime()).orderBy('createdAt', 'desc');
            return query;
        };
    }
    bookmark(id) {
        return this.docPromise(this.refs.bookmarkDocument(id));
    }
    bookmarkByUser(userId, assignmentId) {
        return this.bookmark(domain_1.Bookmark.createId(assignmentId, userId));
    }
    bookmarksForAssignment(assignmentId) {
        return this.collectionPromise(this.bookmarksQuery({ assignmentId }));
    }
    /** Fetches the bookmarks for the given user */
    activeBookmarkForUserStream(userId, createdAfter, limit) {
        return this.findBookmarksStream({
            userId,
            createdAfter,
            isHidden: false,
            limit,
        });
    }
    activeBookmarkForUser(userId, createdAfter, limit) {
        return this.findBookmarks({
            userId,
            createdAfter,
            isHidden: false,
            limit,
        });
    }
    /** Fetches the bookmarks for the given user */
    activeBookmarkForUserInGroupStream(userId, groupId, createdAfter, limit) {
        return this.findBookmarksStream({
            userId,
            createdAfter,
            groupId,
            isHidden: false,
            limit,
        });
    }
    activeBookmarkForUserInGroupModules(userId, modules, isArchived = false) {
        return this.findBookmarksStream({
            userId,
            modules,
            isArchived: isArchived ? isArchived : null,
        });
    }
    /** Fetches the bookmarks for the given user */
    bookmarkForUserInGroupSubject(userId, groupId, createdBefore, limit, archive = false) {
        const query = this.bookmarksQuery({
            userId,
            orderByDate: true,
            beforeDate: createdBefore,
            groupId,
            isHidden: archive ? null : false,
            isArchived: archive ? true : null,
            limit,
        });
        return this.collectionSubjectWithCursorNext(query, limit);
    }
    async allNonRealtimeBookmarksForGroup(groupId) {
        const query = this.bookmarksQuery({
            groupId,
            // isHidden is normally reserved for realtime assignments
            isHidden: false,
        });
        return this.collectionPromise(query);
    }
    async allNonRealtimeBookmarksForModule(moduleId) {
        const query = this.bookmarksQuery({
            modules: [moduleId],
            // isHidden is normally reserved for realtime assignments
            isHidden: false,
        });
        return this.collectionPromise(query);
    }
    async allArchivedNonRealtimeBookmarksForGroup(groupId) {
        const query = this.bookmarksQuery({
            groupId,
            isArchived: true,
        });
        return this.collectionPromise(query);
    }
    /** fetches the most recent realtime bookmark */
    anyRealtimeBookmarkForUserStream(userId) {
        return this.findBookmarksStream({
            userId,
            type: 'realtime',
            limit: 1,
        }).pipe((0, operators_1.map)((bookmarks) => lodash_1.default.first(bookmarks)));
    }
    /** fetches the most recent open tests bookmark where the students are locked in */
    lockedActiveTestsBookmarkForUserStream(userId) {
        const obs = this.findBookmarksStream({
            userId,
            testPhase: 'started',
            lockStudent: true,
            limit: 20,
        });
        return (0, rxjs_1.combineLatest)(obs).pipe((0, operators_1.map)((results) => lodash_1.default.flatMap(results)), (0, operators_1.map)((results) => lodash_1.default.uniqBy(results, (r) => r._id)));
    }
    findBookmarksStream(options) {
        return this.collectionDataStream(this.bookmarksQuery(options), false);
    }
    findBookmarks(options) {
        return this.collectionPromise(this.bookmarksQuery(options));
    }
    async nextBookmarkBatchForMigration(createdBefore, limit) {
        return this.findBookmarks({
            types: ['homework', 'test'],
            createdBeforeDescending: createdBefore,
            limit,
        });
    }
}
exports.BookmarkProvider = BookmarkProvider;
//# sourceMappingURL=BookmarkProvider.js.map